

import { Link } from "react-router-dom"
import { FileText } from "lucide-react"

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-amber-50/80 to-white border-t border-amber-100/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16">
          {/* Logo & Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-8">
              <div className="relative p-3 bg-[#CA8A04] rounded-2xl shadow-lg shadow-[#CA8A04]/20 hover:shadow-[#CA8A04]/30 transition-all duration-300">
                <FileText className="h-7 w-7 text-white" />
                <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent rounded-2xl"></div>
              </div>
              <span className="text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
                TappAnon
              </span>
            </div>
            <p className="text-gray-600 leading-relaxed max-w-lg text-lg font-medium">
              The anonymous platform where HR professionals share and learn from real peers.
              <span className="text-[#CA8A04] font-semibold"> Build better workplaces together.</span>
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-gray-900 mb-8 text-xl relative">
              Platform
              <div className="absolute -bottom-2 left-0 w-8 h-1 bg-[#CA8A04] rounded-full"></div>
            </h3>
            <div className="space-y-5">
              <Link
                to="/"
                className="group flex items-center text-gray-600 hover:text-[#CA8A04] transition-all duration-300 text-lg font-medium"
              >
                <span className="group-hover:translate-x-2 transition-transform duration-300">Home</span>
                <div className="ml-2 w-0 group-hover:w-2 h-0.5 bg-[#CA8A04] transition-all duration-300 rounded-full"></div>
              </Link>
              <Link
                to="/profile"
                className="group flex items-center text-gray-600 hover:text-[#CA8A04] transition-all duration-300 text-lg font-medium"
              >
                <span className="group-hover:translate-x-2 transition-transform duration-300">Profile</span>
                <div className="ml-2 w-0 group-hover:w-2 h-0.5 bg-[#CA8A04] transition-all duration-300 rounded-full"></div>
              </Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-bold text-gray-900 mb-8 text-xl relative">
              Legal
              <div className="absolute -bottom-2 left-0 w-8 h-1 bg-[#CA8A04] rounded-full"></div>
            </h3>
            <div className="space-y-5">
              <Link
                to="/privacy-policy"
                className="group flex items-center text-gray-600 hover:text-[#CA8A04] transition-all duration-300 text-lg font-medium"
              >
                <span className="group-hover:translate-x-2 transition-transform duration-300">Privacy Policy</span>
                <div className="ml-2 w-0 group-hover:w-2 h-0.5 bg-[#CA8A04] transition-all duration-300 rounded-full"></div>
              </Link>
              <Link
                to="/terms-of-service"
                className="group flex items-center text-gray-600 hover:text-[#CA8A04] transition-all duration-300 text-lg font-medium"
              >
                <span className="group-hover:translate-x-2 transition-transform duration-300">Terms of Service</span>
                <div className="ml-2 w-0 group-hover:w-2 h-0.5 bg-[#CA8A04] transition-all duration-300 rounded-full"></div>
              </Link>
              <Link
                to="/contact"
                className="group flex items-center text-gray-600 hover:text-[#CA8A04] transition-all duration-300 text-lg font-medium"
              >
                <span className="group-hover:translate-x-2 transition-transform duration-300">Contact</span>
                <div className="ml-2 w-0 group-hover:w-2 h-0.5 bg-[#CA8A04] transition-all duration-300 rounded-full"></div>
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-10 border-t border-amber-200/50">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
            {/* <p className="text-gray-500 text-lg font-medium">© 2024 TappAnon. All rights reserved.</p> */}
            <p className="text-gray-500 text-lg font-medium">
  © {new Date().getFullYear()} TappAnon. All rights reserved.
</p>

            <div className="flex items-center space-x-3">
              <div className="w-2 h-2 bg-[#CA8A04] rounded-full animate-pulse"></div>
              <p className="text-gray-700 text-lg font-bold bg-gradient-to-r from-[#CA8A04] to-[#B8860B] bg-clip-text text-transparent">
                Anonymous. Professional. Collaborative.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
